<template>
	<div class="delete-text">
		<div v-if="serverStatus.serverBusy" id="delete-loading">
			<span class="loading-icon"></span>
			<span class="loading-message">{{ serverStatus.busyText }}</span>
		</div>
		<div class="delete-container">
			<fieldset>
				<legend>Delete Buy-In</legend>
				<p class="yellow-text">
					You are about to delete {{ buyIn.publicName }}. Do you want to delete this buy in offer?
				</p>
				<div class="flex">
					<button class="btn red-bg" @click="deleteBuyInOffer()">Delete {{ buyIn.publicName }}</button>
					<button class="btn" @click="closeModal()">Cancel</button>
				</div>
			</fieldset>
		</div>
	</div>
</template>

<script>
export default {
	name: "DeleteBuyInModal",
	props: {
		buyIn: Object,
	},
	data() {
		return {
		};
	},
	methods: {
		closeModal() {
			this.eventBus.emit("closeDeleteBuyInModal");
		},

		deleteBuyInOffer(){
			this.eventBus.emit("deleteBuyInOffer");
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#delete-loading {
	position: absolute;
	display: grid;
	align-content: center;
	width: 100%;
	height: 100%;
	z-index: 100;
	background: rgb(0 0 0 / 70%);
	-webkit-backdrop-filter: blur(6px);
	backdrop-filter: blur(6px);
}

.delete-text {
	display: grid;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgb(0 0 0 / 70%);
	backdrop-filter: blur(5px);
	z-index: 100;
}

.delete-container {
	display: flex;
	flex-flow: column nowrap;
	position: relative;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: #222;
	color: #fff;
	width: 80%;
	margin: auto;
	padding: 30px;
	border-radius: 12px;
	text-align: center;
}

.delete-container fieldset {
	display: flex;
	flex-flow: column;
	padding: 30px;
}

.delete-container p,
.delete-container table {
	text-align: left;
}

.delete-container button {
	margin: 5px auto;
}

th,
.header-row {
	text-transform: capitalize;
}

.data-row {
	text-align: right;
}

p.yellow-text {
    text-align: center;
}

.commit {
	background-color: #008000;
}

.cancel {
	background-color: #f00;
}

.flex {
	display: flex;
	flex-direction: row;
}

.delete-h3 {
	margin: 0;
}

#delete-dialog {
	margin: auto;
	background-color: #000;
	color: #fff;
	border-radius: 12px;
	border-width: 1px;
}

::backdrop {
	margin: auto 15px;
	background-color: #000;
	backdrop-filter: blur(8px);
	opacity: 0.75;
}

#btn-container {
	display: flex;
	justify-content: center;

	.btn {
		min-width: 6em;
		min-height: 2.5em;
	}
}

#delete-dialog {
		margin: auto;
}

#dialog-text {
	text-align: center;
}

@media (min-width: 768px) {
	.delete-container {
		width: 50%;
	}
}
</style>
